import axios from "axios";
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useSnackbar } from "notistack";
import { Context } from "../../utils/context";
import { useContext } from "react";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { loginuser, logoutuser } from "../../utils/feature/userSlice";
import { GoogleOAuthProvider, GoogleLogin } from "@react-oauth/google";
import jwt_decode from "jwt-decode";
import { BASE_URL } from "../../utils/BaseURL";

const Login = () => {
  const [email, setEmail] = useState("");
  const { auth, handleauth } = useContext(Context);
  const [password, setPassword] = useState("");
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { enqueueSnackbar } = useSnackbar();
  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      await axios
        .post(BASE_URL + "/users/login", {
          email,
          password,
        })
        .then((res) => {
          dispatch(loginuser(res.data));

          enqueueSnackbar(res?.data?.message, { variant: "success" });
          navigate("/");
        });
    } catch (error) {
      enqueueSnackbar(error?.response?.data?.message || error, {
        variant: "error",
      });
      console.log(error);
    }
  };

  const responseGoogle = (response) => {
    console.log(response);
    // Handle the response from Google Sign-In
  };
  return (
    <div className="min-h-screen z-50 flex flex-col gap-10 items-center justify-center bg-gray-50 py-12 px-4 sm:px-6 lg:px-8 fixed w-full top-0">
      <div className="max-w-md w-full space-y-8">
        <div>
          <h2 className="mt-6 text-center text-3xl font-extrabold text-gray-900">
            Sign in to your account
          </h2>
        </div>
        <form className="mt-8 space-y-6" onSubmit={handleSubmit}>
          <input type="hidden" name="remember" defaultValue="true" />
          <div className="rounded-md shadow-sm space-y-5">
            <div>
              <label htmlFor="email-address" className="sr-only">
                Email address
              </label>
              <input
                id="email-address"
                name="email"
                type="email"
                autoComplete="email"
                required
                className="appearance-none rounded-none relative block w-full px-3 py-2 border border-gray-300 placeholder-gray-500 text-gray-900 rounded-t-md focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 focus:z-10 sm:text-sm"
                placeholder="Email address"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
            </div>
            <div>
              <label htmlFor="password" className="sr-only">
                Password
              </label>
              <input
                id="password"
                name="password"
                type="password"
                autoComplete="current-password"
                required
                className="appearance-none rounded-none relative block w-full px-3 py-2 border border-gray-300 placeholder-gray-500 text-gray-900 rounded-b-md focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 focus:z-10 sm:text-sm"
                placeholder="Password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
              />
            </div>
          </div>

          <div className="flex items-center justify-between">
            <div className="flex items-center">
              <input
                id="remember-me"
                name="remember-me"
                type="checkbox"
                className="h-4 w-4 text-indigo-600 focus:ring-indigo-500 border-gray-300 rounded"
              />
              <label
                htmlFor="remember-me"
                className="ml-2 block text-sm text-gray-900"
              >
                Remember me
              </label>
            </div>
          </div>

          <div>
            <button
              type="submit"
              className="group relative w-full flex justify-center py-2 px-4 border border-transparent text-sm font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
            >
              Sign in
            </button>
          </div>
        </form>
        <div className=" text-center">
          Don't have an account?{" "}
          <span
            onClick={() => navigate("/signup")}
            className=" text-blue-700 cursor-pointer"
          >
            Create One
          </span>
        </div>
      </div>

      <GoogleOAuthProvider clientId="4278052967-26g3noe5vu29aafk0jqopht00i26d1pj.apps.googleusercontent.com">
        <GoogleLogin
          onSuccess={async (credentialResponse) => {
            var decoded = jwt_decode(credentialResponse.credential);

            const option = {
              email: decoded.email,
              password: "Shubham@1",
            };

            try {
              await axios
                .post(BASE_URL + "/users/login", option)
                .then((res) => {
                  dispatch(loginuser(res.data));
                  enqueueSnackbar("login succesfull", { variant: "succes" });
                  navigate("/");
                });
            } catch (error) {
              enqueueSnackbar(error, { variant: "error" });
              console.log(error);
            }
          }}
          onError={() => {
            console.log("Login Failed");
          }}
        ></GoogleLogin>
      </GoogleOAuthProvider>
    </div>
  );
};

export default Login;
